import { BannerProperty, BannerPropertyKey } from '../../_shared';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as moment from 'moment-timezone';
import {
  createStepMediaInitialData,
  externalButtonUsage,
  stepLayout,
  createStepResponseMediaInitialData,
  steps,
  initializeForm,
  patchInputs,
  getTruncatedProductName,
  mediaExcludedSteps,
  getOfferBuilderRoot,
  OfferBuilderSection,
} from '../../steps-library/step-util';
import {
  Breadcrumb,
  OfferTypeLabels,
  OfferTypes,
  StepDateTypes,
  StepPopupActions,
  StepStatusLabels,
  StepStatuses,
  CampaignProduct,
  StepCategoryLabels,
  User,
  StepEmulatorDevices,
  FunnelType,
  StepStaticDataImageType,
  getCampaignProductImageUrl,
  Campaign,
  Style,
  defaultThemeColor,
  FunnelStep,
  getDiscountSettingFromStep,
  OfferIntents,
  StepTypePopupData,
  CategoryTitles,
  StepHeaderDetails,
  Audience,
  StepTableStatusLabels,
  StepTableStatuses,
  StepCategory,
  CustomStepCategoryEnum,
  Funnel,
  OfferStages, FunnelInputTypeEnum, FunnelInput,
} from '../../_models';
import {
  AlertService,
  AudienceService,
  CampaignService,
  FunnelInputService,
  FunnelService,
  FunnelStepService,
  StepEmulatorService,
  StepTemplateService,
  StorageService,
  StyleService,
  UserService,
} from '../../_services';
import { Subject, forkJoin, of } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Form } from '../../_forms';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { config } from '../../../config/config';
import { takeUntil, map, mergeMap, catchError } from 'rxjs/operators';
import { OfferViewLayouts } from './stage-details';
import { SurveyStep } from '../survey/survey';
import { SideNavService } from '../../_services/sidenav.service';
import { Step } from '../retention/retention';

@Component({
  selector: 'app-stage-details',
  templateUrl: './stage-details.component.html',
  styleUrls: ['./stage-details.component.scss'],
})
export class StageDetailsComponent extends Form implements OnInit, OnDestroy {
  steps = steps;
  isTableVisible: boolean = true;
  showThreeDotMenu: boolean = false;
  offer: any;
  offerId: number;
  reactivatePath: number;
  offerIntent: OfferIntents;
  segmentId: number;
  segment: Audience;
  selectedDate: StepDateTypes = StepDateTypes.LastModified;
  tableDateTypes = StepDateTypes;
  tableData: any[];
  originalTableData: any[];
  offerSteps: any[];
  originalOfferSteps: any[];
  originalSteps: any[];
  originalReactivateOfferSteps: any[] = [];
  downsellOfferSteps: any[] = [];
  reactivateOfferSteps: any[] = [];
  reactivateOffer: any = null;
  hoveredStepIndex: string | null = null;
  stepPopupActions = StepPopupActions;
  popupTitle: string = '';
  breadcrumbs: Breadcrumb[] = [];
  stepDiscounts = {};
  popupData = {
    name: '',
    is_survey: false,
    offer_id: null,
    step_id: null,
    is_step: true,
    offer_intent: null,
    offer_type: null,
    popupType: null,
    is_reactivate_offer: false,
    step_response: {},
  };
  stepTypePopupData: StepTypePopupData = {
    is_survey: false,
    offer_name: '',
    offer_id: null,
    offer_intent: null,
    offer_type: null,
    popupType: null,
    steps: [],
    use_existing_template: false,
  };
  stepTypePopupTitle = '';
  stepSubtypePopupTitle = '';
  stepSubtypePopupSubtitle = '';
  stepStatuses = StepStatuses;
  stepStatusLabels = StepStatusLabels;
  stepPopupTitleMap = {
    [StepPopupActions.Update]: 'Rename Step',
    [StepPopupActions.Duplicate]: 'Duplicate Step',
    [StepPopupActions.Delete]: 'Delete Step',
  };
  campaign: Campaign;
  randomProduct: CampaignProduct = null;
  selectedProduct: CampaignProduct = null;
  statuses = [
    { value: StepStatuses.All, label: StepStatusLabels[StepStatuses.All] },
    { value: StepStatuses.Enabled, label: StepStatusLabels[StepStatuses.Enabled] },
    { value: StepStatuses.Disabled, label: StepStatusLabels[StepStatuses.Disabled] },
  ];
  selectedStatus = StepStatuses.All;
  activeDevice = StepEmulatorDevices.Mobile;
  productPlaceholderUrl: string = '';
  theme: string = defaultThemeColor;
  themes: Style[] = [];
  stepsReordering = false;
  tableLoading = true;
  user: User;
  stepsPerView = 3;
  currentIndex = 0;
  previewsLoading = true;
  properties: BannerProperty[] = [];
  stepHeaderDetails = StepHeaderDetails;
  offerLoading: boolean = true;
  layouts = OfferViewLayouts;
  selectedLayout = OfferViewLayouts.Tab;
  isTableCollapsed: boolean = false;
  stepCategoryLabels = StepCategoryLabels;
  isAdminView: boolean = false;
  currentSection: OfferBuilderSection = OfferBuilderSection.Retention;
  surveyStep: SurveyStep;
  isPublishable: boolean = false;
  isPublishing: boolean = false;
  stepsTogglingStatus: Set<number> = new Set();
  public surveyCategories: StepCategory[] = [
    CustomStepCategoryEnum.Survey,
    CustomStepCategoryEnum.CancelOrderSurvey,
    CustomStepCategoryEnum.CancelTrialSurvey,
    CustomStepCategoryEnum.CancelSubSurvey,
    CustomStepCategoryEnum.ReturnSurvey,
  ];

  protected _destroy$: Subject<boolean> = new Subject<boolean>();
  private stepForms = {};
  readonly StepPopupActions = StepPopupActions;

  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    private funnelService: FunnelService,
    private funnelStepService: FunnelStepService,
    private campaignService: CampaignService,
    private stepEmulatorService: StepEmulatorService,
    protected styleService: StyleService,
    public ngxSmartModalService: NgxSmartModalService,
    protected alertService: AlertService,
    private sanitizer: DomSanitizer,
    protected inputService: FunnelInputService,
    protected formBuilder: FormBuilder,
    protected userService: UserService,
    protected location: Location,
    protected storageService: StorageService,
    protected audienceService: AudienceService,
    protected stepTemplateService: StepTemplateService,
    protected sideNav: SideNavService
  ) {
    super(alertService, router, location);
    this.route.params.subscribe((params) => {
      this.offerId = params['offer_id'];
      this.segmentId = params['segment_id'];
      this.reactivatePath = this.storageService.get('reactivatePath') || null;
      this.offerIntent = this.storageService.get('offerIntent') || null;

      this.properties = [
        { key: BannerPropertyKey.Id, label: 'ID', value: this.offerId },
        { key: BannerPropertyKey.Status, label: 'Status', value: null },
        { key: BannerPropertyKey.Survey, label: 'Survey', value: null },
        { key: BannerPropertyKey.LastModified, label: 'Last Modified', value: null },
      ];
      this.sideNav.setSideNavExpanded(false);
    });
  }

  ngOnInit() {
    this.funnelStepService.setFunnelId(this.offerId);
    this.campaign = this.campaignService.getCurrentCampaign();
    this.isAdminView = this.route.snapshot.data['isAdminView'];
    this.currentSection = this.route.snapshot.data['section'];

    if (this.segmentId) {
      this.fetchSegment(this.segmentId);

      this.properties.splice(1, 0, {
        key: BannerPropertyKey.OfferGroup,
        label: 'Offer Group',
        value: null,
      });
    }

    const shouldCreateReactivateOffer = !this.reactivatePath && this.offerIntent === OfferIntents.CancelSubscription;

    forkJoin({
      user: this.userService.getCurrent().pipe(
        catchError((error) => {
          console.error('Error fetching user:', error);
          return of(null);
        })
      ),
      styles: this.styleService
        .getVariables({ page: 1, page_size: config.maxPageSize, campaigns: this.campaign.id })
        .pipe(
          catchError((error) => {
            console.error('Error fetching styles:', error);
            return of({ results: [] });
          })
        ),
      offer: this.funnelService.get(this.offerId).pipe(
        catchError((error) => {
          console.error('Error fetching offer:', error);
          return of(null);
        })
      ),
      offerSteps: this.funnelStepService.getOfferSteps().pipe(
        catchError((error) => {
          console.error('Error fetching offer steps:', error);
          return of([]);
        })
      ),
      reactivateOffer: shouldCreateReactivateOffer
        ? this.funnelService.create(this.getReactivateOfferFormData()).pipe(
            catchError((error) => {
              console.error('Error creating reactivate offer:', error);
              return of(null);
            })
          )
        : of(null),
      reactivateOfferDetails: this.reactivatePath
        ? this.funnelService.get(this.reactivatePath).pipe(
            catchError((error) => {
              console.error('Error fetching reactivate offer details:', error);
              return of(null);
            })
          )
        : of(null),
    })
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: ({ user, styles, offer, offerSteps, reactivateOffer, reactivateOfferDetails }) => {
          if (reactivateOffer) {
            this.reactivatePath = Number((reactivateOffer as Funnel).id);
            this.storageService.set('reactivatePath', this.reactivatePath);
          }

          if (reactivateOfferDetails) {
            this.reactivateOffer = reactivateOfferDetails;
            this.processReactivateOffer();
            this.originalReactivateOfferSteps = [...this.reactivateOfferSteps];
          }

          if (user) {
            this.user = user;
            this.generateBreadcrumbs();
          }

          this.themes = styles && styles.results ? styles.results : [];

          if (this.themes.length && this.campaign.styles.length) {
            const selectedTheme = this.themes.find((theme) => theme.id === this.campaign.styles[0]);
            if (selectedTheme && selectedTheme.variables && selectedTheme.variables.theme_color) {
              this.theme = selectedTheme.variables.theme_color;
            }
          }

          if (offer) {
            this.offer = offer;
            this.isPublishable = this.offer.is_modified;
            this.updateBreadCrumbs();
            this.updateBannerProperties();
            this.offerLoading = false;
            this.originalOfferSteps = offer.offer_steps || [];
            this.processOffer();
            this.surveyStep = this.offer.survey ? this.offer.survey : null;
            this.setSurveyProperty();
            this.setOfferGroup();
          }

          if (Array.isArray(offerSteps)) {
            this.tableLoading = false;
            this.offerSteps = offerSteps;
            this.originalSteps = offerSteps;
            this.offerSteps.forEach((step) => {
              if (step) {
                step.loading = false;
                step.converting = false;
              }
            });
            this.populateTableData();
          } else {
            this.offerSteps = [];
          }

          this.setProduct();
        },
        error: (error) => {
          this.tableLoading = false;
          this.previewsLoading = false;
          this.handleError(error);
        },
      });
  }

  fetchSegment(segmentId: number) {
    this.audienceService.get(segmentId).subscribe({
      next: (segment: Audience) => {
        this.segment = segment;
      },
      error: (error) => {
        this.handleError(error);
      },
    });
  }

  updateBreadCrumbs() {
    if (this.segmentId) {
      this.breadcrumbs[1].url = this.isAdmin
        ? ['admin', 'retention', 'stage', this.offerId, 'segment']
        : [getOfferBuilderRoot(this.currentSection), 'stage', this.offerId, 'segment'];
      this.breadcrumbs[2].label = this.segment.name;
    } else {
      this.breadcrumbs[1].label = OfferStages[this.offer.offer_intent];
    }
  }

  updateBannerProperties(): void {
    const source: any = this.segmentId ? this.segment : this.offer;

    const valueMap: Partial<Record<BannerPropertyKey, any>> = {
      [BannerPropertyKey.Id]: source && source.id != null ? String(source.id) : null,

      [BannerPropertyKey.Status]:
        this.offer && this.offer.is_active
          ? StepTableStatusLabels[StepTableStatuses.Active]
          : StepTableStatusLabels[StepTableStatuses.Inactive],

      [BannerPropertyKey.LastModified]: this.getFormattedDate(source ? source.updated : null),
    };

    this.properties = this.properties.map((prop) => {
      if (valueMap.hasOwnProperty(prop.key)) {
        return { ...prop, value: valueMap[prop.key] };
      }
      return prop;
    });
  }

  setSurveyProperty() {
    const surveyProp = this.properties.find((prop) => prop.key === BannerPropertyKey.Survey);

    if (this.surveyStep) {
      surveyProp.value = this.surveyStep.name;
      surveyProp.route = this.getSurveyRoute(this.surveyStep);
    } else {
      surveyProp.value = '--';
      surveyProp.route = null;
    }
  }

  setOfferGroup() {
    if (this.segmentId) {
      const offerProp = this.properties.find((prop) => prop.key === BannerPropertyKey.OfferGroup);
      if (this.offer) {
        offerProp.value = OfferStages[this.offer.offer_intent];
        offerProp.route = [getOfferBuilderRoot(this.currentSection), 'stage', this.offerId];
      } else {
        offerProp.value = '--';
        offerProp.route = null;
      }
    }
  }

  getStepLayout(step: FunnelStep) {
    return stepLayout[step.category] || [];
  }

  getStepForm(step: FunnelStep) {
    return this.stepForms[step.id];
  }

  getSurveyRoute(survey: SurveyStep): (string | number)[] {
    let route: (string | number)[] = [];

    if (this.isAdmin) {
      route = [
        'admin',
        'survey',
        'intent',
        survey.offer_intent,
        'category',
        OfferTypes.Survey,
        survey.category,
        'step',
        survey.id,
      ];
    } else {
      route = ['survey', 'stage', survey.funnel, 'category', OfferTypes.Survey, survey.category, 'step', survey.id];
    }
    return route;
  }

  private processStep(step: Step, offerType: number): void {
    const form = initializeForm(this.formBuilder, step.category, offerType, false);
    if (form) {
      if (!mediaExcludedSteps.includes(step.category)) {
        form.setControl(
          'static_data',
          this.formBuilder.group({
            image: null,
            image_tablet: null,
            image_mobile: null,
            embed_code: null,
            image_type: StepStaticDataImageType.None,
          })
        );
      }
      this.stepForms[step.id] = form;
    }

    step.useExternalButtons = externalButtonUsage(step.category);
    const stepMedia = createStepMediaInitialData();
    const stepResponseMedia = createStepResponseMediaInitialData();

    patchInputs(
      form,
      this.formBuilder,
      step,
      step.useExternalButtons,
      stepMedia,
      stepResponseMedia,
      this.sanitizer,
      this.stepEmulatorService
    );
  }

  private processOffer() {
    this.offer.offer_steps.forEach((step: Step) => {
      if (step) {
        this.processStep(step, this.offer.offer_type);
      }
    });
    this.previewsLoading = false;
    this.refreshFilteredSteps();
  }

  private processReactivateOffer(): void {
    const offerSteps = this.reactivateOffer && this.reactivateOffer.offer_steps ? this.reactivateOffer.offer_steps : [];
    offerSteps.forEach((step) => {
      if (step) {
        step.loading = false;
        step.converting = false;
        this.processStep(step, this.reactivateOffer.offer_type);
      }
    });
    this.reactivateOfferSteps = offerSteps.filter(
      (step) => step && step.category === CustomStepCategoryEnum.ReActivateSubscriptionWithDiscount
    );
  }

  refreshOffer() {
    this.previewsLoading = true;
    this.tableLoading = true;
    return forkJoin({
      offer: this.funnelService.get(this.offerId),
      offerSteps: this.funnelStepService.getOfferSteps(),
    }).pipe(
      map(({ offer, offerSteps }) => {
        if (offer) {
          this.offer = offer;
          this.originalOfferSteps = offer.offer_steps || [];
          this.processOffer();
        }
        if (offerSteps && offerSteps.length) {
          this.tableLoading = false;
          this.offerSteps = offerSteps;
          this.originalSteps = offerSteps;
          this.offerSteps.forEach((step) => (step.loading = false));
          this.populateTableData();
        } else {
          this.offerSteps = [];
        }
        this.onStatusChange();
        this.stepsReordering = false;
        this.previewsLoading = false;
        return { offer, offerSteps };
      }),
      takeUntil(this._destroy$)
    );
  }

  setProduct() {
    const product = this.storageService.get('selectedStepProduct');
    if (product && product.id) {
      setTimeout(() => {
        this.onProductSelected(product);
      }, 1000);
    } else {
      if (!this.randomProduct) {
        this.getRandomPreviewProduct();
      }
    }
  }

  publish() {
    if (this.isPublishable) {
      this.isPublishing = true;

      const publishObservables: any = {};

      if (this.offer && this.offer.is_modified) {
        publishObservables.main = this.funnelService.publish(this.offer.id);
      }

      if (this.reactivatePath && this.reactivateOffer && this.reactivateOffer.is_modified) {
        publishObservables.reactivate = this.funnelService.publish(this.reactivatePath);
      }

      forkJoin(publishObservables)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            if (publishObservables.main) {
              this.offer.is_modified = false;
            }
            if (publishObservables.reactivate) {
              this.reactivateOffer.is_modified = false;
            }
            this.isPublishable = false;
            this.alertService.success('Path changes are being published.', true);
            this.isPublishing = false;
          },
          (error) => {
            this.handleError(error);
            this.isPublishing = false;
          }
        );
    }
  }

  populateTableData() {
    this.tableData = this.offerSteps.map((item: any) => {
      const lastModifiedMoment = moment(item.last_modified).tz('EST');
      const lastModifiedObject = {
        date: lastModifiedMoment.format('DD MMM, YYYY'),
        time: lastModifiedMoment.format('HH:mm:ss z'),
      };

      const stepInput = this.getStepInput(item.id);

      return {
        id: item.id,
        stepName: item.name,
        status: stepInput.enabled
          ? StepStatuses.Enabled
          : !stepInput.enabled
            ? StepStatuses.Disabled
            : StepStatuses.Draft,
        type: StepCategoryLabels[item.category],
        stepInput: stepInput,
        lastModified: lastModifiedObject,
        visitors: item.visitors || 0,
        category: item.category,
        clicks: item.clicks || 0,
        takeRates: item.clicks && item.visitors ? (item.clicks / item.visitors) * 100 : 0,
        averageTime: item.averageTime || '--',
        usages:
          item.path_names && item.path_names.length
            ? `${item.path_names.length} ${item.path_names.length > 1 ? 'Paths' : 'Path'}`
            : '0 Paths',
        displayId: item.display_id,
      };
    });
    this.originalTableData = this.tableData;
  }

  protected getRandomPreviewProduct() {
    if (this.campaign) {
      this.campaignService
        .getRandomPreviewProduct(this.campaign.id)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (response: any) => {
            this.randomProduct = response;
            this.productPlaceholderUrl = getCampaignProductImageUrl(this.randomProduct);
          },
          error: (error) => {
            this.randomProduct = null;
            this.productPlaceholderUrl = '';
            if (error.status !== 404) {
              this.handleError(error);
            }
          },
        });
    }
  }

  onStatusChange(): void {
    if (+this.selectedStatus === StepStatuses.All) {
      this.tableData = [...this.originalTableData];
      this.offerSteps = [...this.originalSteps];
      this.offer.offer_steps = [...this.originalOfferSteps];
      this.reactivateOfferSteps = [...this.originalReactivateOfferSteps];
    } else {
      this.tableData = this.originalTableData.filter((item) => item.status === +this.selectedStatus);
      this.offerSteps = this.originalSteps.filter((step) => this.tableData.find((item) => item.id === step.id));
      this.offer.offer_steps = this.originalOfferSteps.filter((step) =>
        this.tableData.find((item) => item.id === step.id)
      );
      const filterEnabled = +this.selectedStatus === StepStatuses.Enabled;
      this.reactivateOfferSteps = this.originalReactivateOfferSteps.filter(
        (step) => this.isStepEnabled(step.id) === filterEnabled
      );
    }
    this.refreshFilteredSteps();
  }

  toggleStepStatus(stepId: number): void {
    this.stepsTogglingStatus.add(stepId);
    this.toggleStatus(stepId);
  }

  toggleStatus(stepId: number): void {
    const isReactivateStep = this.reactivateOfferSteps.some((s) => s.id === stepId);
    let offerStep = null;

    if (isReactivateStep) {
      const reactivateSteps =
        this.reactivateOffer && this.reactivateOffer.offer_steps ? this.reactivateOffer.offer_steps : [];
      offerStep =
        reactivateSteps.find(({ id }) => id === stepId) || this.reactivateOfferSteps.find(({ id }) => id === stepId);
    } else {
      offerStep = this.offer.offer_steps.find(({ id }) => id === stepId);
    }

    if (!offerStep) {
      this.stepsTogglingStatus.delete(stepId);
      this.alertService.error('Step not found', true);
    } else {
      const updatedInputs: FunnelInput[] = offerStep.inputs.map((input) => ({
        id: input.id,
        type: input.type,
        enabled: input.has_response_step ? !input.enabled : input.enabled,
      }));

      // for troubleshooters, we will disable failed input as well so we can skip the troubleshooter
      if (offerStep.type === FunnelInputTypeEnum.EnterTroubleshooter) {
        const passedInputIndex = updatedInputs.findIndex((input) => input.type === FunnelInputTypeEnum.EnterTroubleshooter);
        const failedIndex = updatedInputs.findIndex((input) => input.type === FunnelInputTypeEnum.AltChildExit);

        if (passedInputIndex > -1 && failedIndex > -1) {
          updatedInputs[failedIndex].enabled = updatedInputs[passedInputIndex].enabled
        }
      }

      const payload = {
        id: stepId,
        inputs: updatedInputs,
      };

      if (isReactivateStep) {
        this.funnelStepService.setFunnelId(this.reactivatePath);
      }

      this.funnelStepService.patch(stepId, payload).subscribe(
        () => {
          payload.inputs.forEach((updatedInput) => {
            const existingInput = offerStep.inputs.find((input) => input.id === updatedInput.id);
            if (existingInput) {
              existingInput.enabled = updatedInput.enabled;
            }
          });

          const tableItem = this.originalTableData.find((item) => item.id === stepId);
          if (tableItem) {
            const updatedStepInput = offerStep.inputs.find((input) => input.has_response_step);
            if (updatedStepInput) {
              tableItem.status = updatedStepInput.enabled ? StepStatuses.Enabled : StepStatuses.Disabled;
            }
          }
          this.onStatusChange();

          if (isReactivateStep) {
            this.reactivateOffer.is_modified = true;
          } else {
            this.offer.is_modified = true;
          }
          this.funnelStepService.setFunnelId(this.offerId);
          this.isPublishable = true;
          this.stepsTogglingStatus.delete(stepId);

          this.alertService.success('Step status updated successfully, Publish when ready.', true);
        },
        (error) => {
          this.funnelStepService.setFunnelId(this.offerId);
          this.stepsTogglingStatus.delete(stepId);
          this.handleError(error);
        }
      );
    }
  }

  isStepEnabled(stepId: number): boolean {
    const stepInput = this.getStepInput(stepId);
    return stepInput ? stepInput.enabled : false;
  }

  getStepInput(stepId: number) {
    let result = null;
    const isReactivateStep = this.reactivateOfferSteps.some((s) => s.id === stepId);

    if (isReactivateStep) {
      const reactivateSteps =
        this.reactivateOffer && this.reactivateOffer.offer_steps ? this.reactivateOffer.offer_steps : [];
      const step =
        reactivateSteps.find(({ id }) => id === stepId) || this.reactivateOfferSteps.find(({ id }) => id === stepId);
      if (step && step.inputs) {
        result = step.inputs.find(({ has_response_step }) => has_response_step);
      }
    } else {
      const offerStep = this.offer.offer_steps.find(({ id }) => id === stepId);
      if (offerStep) {
        result = offerStep.inputs.find(({ has_response_step }) => has_response_step);
      }
    }
    return result;
  }

  generateBreadcrumbs() {
    if (this.segmentId) {
      this.breadcrumbs = [
        {
          label: 'Offer Builder',
          url: this.isAdmin ? ['admin', 'retention'] : [getOfferBuilderRoot(this.currentSection)],
        },
        {
          label: 'Segments',
          url: [],
        },
        {
          label: '',
        },
      ];
    } else {
      this.breadcrumbs = [
        {
          label: 'Offer Builder',
          url: this.isAdmin ? ['admin', 'retention'] : [getOfferBuilderRoot(this.currentSection)],
        },
        {
          label: '',
        },
      ];
    }
  }

  openPopup(popupType: number, stepId?: number | string, stepName?: string, isReactivateOffer: boolean = false): void {
    this.popupTitle = this.stepPopupTitleMap[popupType] || '';
    const stepResponse = this.offerSteps.find((step) => step.id === stepId);
    this.popupData = {
      ...this.popupData,
      name: stepName || '',
      step_id: stepId || null,
      offer_id: isReactivateOffer ? this.reactivatePath : this.offerId || null,
      step_response: stepResponse || {},
      popupType: popupType,
    };

    if (popupType === StepPopupActions.Duplicate) {
      this.popupData['parent_inputs'] = this.getParentInputForNewStep(isReactivateOffer);
    }
    this.ngxSmartModalService.getModal('stepPopup').open();
  }

  getParentInputForNewStep(isReactivateOffer: boolean = false) {
    const parent_inputs = [];
    const offerSteps = isReactivateOffer
      ? this.reactivateOffer && this.reactivateOffer.offer_steps
      : this.offer && this.offer.offer_steps;
    if (offerSteps && offerSteps.length > 0) {
      const lastStepIndex = offerSteps.length - 1;
      if (offerSteps[lastStepIndex].inputs && offerSteps[lastStepIndex].inputs.length > 0) {
        offerSteps[lastStepIndex].inputs.forEach((input: any) => {
          if (!input.has_response_step) {
            parent_inputs.push(input.id);
          }
        });
      }
    }

    return parent_inputs;
  }

  closeStepPopup() {
    this.ngxSmartModalService.getModal('stepPopup').close();
  }

  closeStepTypePopup() {
    this.ngxSmartModalService.getModal('stepTypePopup').close();
  }

  closeStepSubtypePopup() {
    this.ngxSmartModalService.getModal('stepSubtypePopup').close();
  }

  saveStepType(event: { path: string[]; selectedType: CustomStepCategoryEnum }) {
    // Check if the selected step has subtypes
    const stepWithSubtypes = steps.find((step) => step.subtypes && step.type === event.selectedType);

    if (stepWithSubtypes) {
      this.closeStepTypePopup();
      this.openStepSubtypePopup(stepWithSubtypes);
    } else {
      // No subtypes, proceed with navigation
      this.closeStepTypePopup();
      this.router.navigate(event.path, { relativeTo: this.route });
    }
  }

  saveStepSubtype(event: { path: string[] }) {
    this.closeStepSubtypePopup();
    this.router.navigate(event.path, { relativeTo: this.route });
  }

  reopenStepTypePopup() {
    this.closeStepSubtypePopup();

    this.stepTypePopupData = {
      ...this.stepTypePopupData,
      steps: this.filterSteps(this.offer.offer_type, this.popupData.offer_intent) || [],
    };

    this.ngxSmartModalService.getModal('stepTypePopup').open();
  }

  openStepSubtypePopup(selectedStep: any) {
    const isPauseSubType = selectedStep.type === CustomStepCategoryEnum.PauseSub;
    const title = isPauseSubType ? 'Pause Options' : 'Swap Offer';
    const subtitle = isPauseSubType
      ? 'Downsell allowing customers to temporarily pause subscriptions as an alternative to cancellation.'
      : 'Offer allowing customers to exchange or swap their product/package.';

    this.stepTypePopupData = {
      ...this.stepTypePopupData,
      steps: selectedStep.subtypes || [],
    };

    this.stepSubtypePopupTitle = title;
    this.stepSubtypePopupSubtitle = subtitle;

    this.ngxSmartModalService.getModal('stepSubtypePopup').open();
  }

  get stepSubtypeModalClass(): string {
    const stepCount = this.stepTypePopupData.steps.length || 0;
    return stepCount >= 3 ? 'nsm-dialog-lg nsm-centered' : 'nsm-dialog-md nsm-centered';
  }

  saveStep(data: any): void {
    const { step_id, popupType, response } = data;
    switch (popupType) {
      case StepPopupActions.Update:
        this.tableData = this.tableData.map((item) => {
          if (item.id === step_id) {
            item.stepName = data.name;
          }
          return item;
        });
        this.offerSteps = this.offerSteps.map((step) => {
          if (step.id === step_id) {
            step.name = data.name;
          }
          return step;
        });
        this.offer.offer_steps = this.offer.offer_steps.map((step) => {
          if (step.id === step_id) {
            step.name = data.name;
          }
          return step;
        });
        break;

      case StepPopupActions.Delete:
        const isReactivateDelete = this.reactivateOfferSteps.some((s) => s.id === step_id);
        if (isReactivateDelete) {
          this.reactivateOfferSteps = this.reactivateOfferSteps.filter((step) => step.id !== step_id);
          if (this.reactivateOffer && this.reactivateOffer.offer_steps) {
            this.reactivateOffer.offer_steps = this.reactivateOffer.offer_steps.filter(
              (step: Step) => step.id !== step_id
            );
          }
        } else {
          this.tableData = this.tableData.filter((item) => item.id !== step_id);
          this.offerSteps = this.offerSteps.filter((step: Step) => step.id !== step_id);
          this.offer.offer_steps = this.offer.offer_steps.filter((step: Step) => step.id !== step_id);
          this.refreshFilteredSteps();
        }
        break;

      case StepPopupActions.Duplicate:
        this.navigateToStepBuilder(response.category, response.id);
        break;

      default:
        this.refreshOffer()
          .pipe(takeUntil(this._destroy$))
          .subscribe({
            next: () => {
              this.previewsLoading = false;
              this.alertService.success('Step updated successfully');
            },
            error: (error) => {
              this.previewsLoading = false;
              this.handleError(error);
            },
          });
        break;
    }
    this.ngxSmartModalService.getModal('stepPopup').close();
  }

  saveTemplate(event: { use_existing_template: boolean, campaign: string | number }): void {
    // Close the template popup modal
    this.ngxSmartModalService.getModal('templatePopup').close();

    if (!this.isAdminView && this.popupData.popupType === StepPopupActions.CloneOffer) {
      const campaign = event.campaign

      if (campaign) {
        const payload = {is_parent_retention_stage: !this.segmentId}
        this.funnelService.clone(this.offerId, campaign, payload)
          .subscribe(_ => {
            this.alertService.success('Stage is being cloned in the selected brand.')
          }, error => {
            this.handleError(error)
          })
      }
    } else {

      // Prepare data for the step type popup
      this.stepTypePopupData = {
        ...this.stepTypePopupData,
        offer_name: OfferTypeLabels[this.offer.offer_type],
        offer_id: this.popupData.offer_id,
        offer_intent: this.popupData.offer_intent,
        offer_type: this.offer.offer_type,
        use_existing_template: event.use_existing_template,
        popupType: StepPopupActions.SelectType,
        steps: this.filterSteps(this.offer.offer_type, this.popupData.offer_intent) || [],
      };

      this.stepTypePopupTitle = CategoryTitles[this.offer.offer_type];

      // if it's a reactivate offer, we want to navigate directly to the step builder with the template/step selection, otherwise open the step type popup
      if (this.popupData.is_reactivate_offer) {
        const route = ['category', OfferTypes.Downsell, event.use_existing_template ? 'template' : 'step', CustomStepCategoryEnum.ReActivateSubscriptionWithDiscount];
        this.router.navigate(route, { relativeTo: this.route });
      } else {
        this.ngxSmartModalService.getModal('stepTypePopup').open();
      }
    }

  }

  filterSteps(offerType: OfferTypes, offerIntent: OfferIntents): any[] {
    return this.steps.filter(
      (step) =>
        step.offer_type === offerType &&
        (!step.offer_intents || step.offer_intents.length === 0 || step.offer_intents.includes(offerIntent))
    );
  }

  openTemplatePopup(isReactivateOffer: boolean = false) {
    this.popupData = {
      ...this.popupData,
      offer_id: this.offerId,
      offer_intent: this.offer.offer_intent,
      popupType: StepPopupActions.CreateTemplate,
      is_reactivate_offer: isReactivateOffer,
    };
    this.ngxSmartModalService.getModal('templatePopup').open();
  }

  openClonePopup() {
    this.popupData = {
      ...this.popupData,
      offer_id: this.offerId,
      offer_intent: this.offer.offer_intent,
      popupType: StepPopupActions.CloneOffer,
      is_reactivate_offer: false,
    };
    this.ngxSmartModalService.getModal('templatePopup').open();
  }

  closeTemplatePopup() {
    this.ngxSmartModalService.getModal('templatePopup').close();
  }

  openProductSelector() {
    this.ngxSmartModalService.getModal('productPopup').open();
  }

  onProductSelected(product: CampaignProduct) {
    if (product) {
      this.selectedProduct = product;
      this.storageService.set('selectedStepProduct', product);
      this.productPlaceholderUrl = this.selectedProduct.id ? getCampaignProductImageUrl(this.selectedProduct) : null;
    }
    this.ngxSmartModalService.getModal('productPopup').close();
  }

  navigate(url: any[]) {
    this.router.navigate(url);
  }

  navigateToStepBuilder(category: number, stepId: number) {
    this.router.navigate(['category', this.offer.offer_type, category, 'step', stepId], { relativeTo: this.route });
  }

  private getReactivateOfferFormData() {
    return {
      id: +this.offerId,
      name: 'Reactivate Offer',
      campaign: this.campaign.id,
      offer_intent: OfferIntents.ReactivateSubscription,
      offer_type: OfferTypes.Downsell,
      resourcetype: FunnelType.Product,
      is_visual: true,
      is_voice: false,
      is_sms: false,
    };
  }

  private normalizeStaticData(static_data) {
    const normalized = { ...static_data };
    normalized.image = normalized.image
      ? typeof normalized.image === 'object'
        ? normalized.image.id
        : normalized.image
      : null;
    normalized.image_mobile = normalized.image_mobile
      ? typeof normalized.image_mobile === 'object'
        ? normalized.image_mobile.id
        : normalized.image_mobile
      : null;
    normalized.image_tablet = normalized.image_tablet
      ? typeof normalized.image_tablet === 'object'
        ? normalized.image_tablet.id
        : normalized.image_tablet
      : null;
    return normalized;
  }

  openPreview(stepId: number, isReactivate: boolean = false) {
    const productId =
      (this.selectedProduct && this.selectedProduct.id) || (this.randomProduct && this.randomProduct.id) || null;
    const offerStep = isReactivate
      ? this.reactivateOfferSteps.find((step) => step.id === stepId)
      : this.offerSteps.find((step) => step.id === stepId);
    const sourceOffer = isReactivate ? this.reactivateOffer : this.offer;
    const originalStep = sourceOffer && sourceOffer.steps && sourceOffer.steps.find((offer_step: any) => offer_step.id === stepId);
    const step = JSON.parse(JSON.stringify(originalStep));

    // change image objects to ids for preview
    if (step.static_data) {
      step.static_data = this.normalizeStaticData(step.static_data);
    }

    if (step.response_data && step.response_data.static_data) {
      step.response_data.static_data = this.normalizeStaticData(step.response_data.static_data);
    }

    if (offerStep) {
      offerStep.loading = true;

      this.funnelStepService.preview(this.campaign.id, step, productId).subscribe(
        (data: string) => {
          window.open(data, '_blank');
          offerStep.loading = false;
        },
        (error) => {
          this.handleError(error);
          offerStep.loading = false;
        }
      );
    }
  }

  toggleTable() {
    this.isTableVisible = !this.isTableVisible;
  }

  toggleTableCollapse(): void {
    this.isTableCollapsed = !this.isTableCollapsed;
  }

  closeOtherMenus(currentItem: any): void {
    this.tableData.forEach((item) => {
      if (item.id !== currentItem.id) {
        item.showThreeDotMenu = false;
      }
    });
  }

  closeOutside() {
    if (this.tableData) {
      this.tableData.forEach((item) => {
        item.showThreeDotMenu = false;
      });
    }
  }

  toggleThreeDotMenu(item: any, event: MouseEvent): void {
    event.preventDefault();
    this.closeOtherMenus(item);
    item.showThreeDotMenu = !item.showThreeDotMenu;
  }

  closeThreeDotMenu(item: any) {
    item.showThreeDotMenu = false;
  }

  setHoveredStep(id: string) {
    this.hoveredStepIndex = id;
  }
  clearHoveredStep() {
    this.hoveredStepIndex = null;
  }

  navigateToStepTemplates() {
    if (this.offer.offer_type === OfferTypes.Downsell)
      this.router.navigate([
        'steps',
        this.offerName,
        this.offerId,
        'category',
        this.offer.offer_type,
        'intent',
        this.offer.offer_intent,
      ]);
    else this.router.navigate(['steps', this.offerName, this.offerId, 'category', this.offer.offer_type]);
  }

  get destroy$() {
    return this._destroy$.asObservable();
  }

  getProductName(): string {
    if (this.selectedProduct && this.selectedProduct.name) {
      return getTruncatedProductName(this.selectedProduct.name);
    } else if (this.randomProduct && this.randomProduct.name) {
      return getTruncatedProductName(this.randomProduct.name);
    }
  }

  popupIconMap: Partial<Record<StepPopupActions, string>> = {
    [StepPopupActions.Delete]: '/assets/stepAssets/delete-icon.svg',
    [StepPopupActions.Duplicate]: '/assets/stepAssets/duplicate.svg',
    [StepPopupActions.Update]: '/assets/stepAssets/rename.svg',
  };

  convertToTemplate(stepId: string | number, is_global: boolean = false) {
    const isReactivateStep = this.reactivateOfferSteps.some((s) => s.id === stepId);
    const offerStep = isReactivateStep
      ? this.reactivateOfferSteps.find((step) => step.id === stepId)
      : this.offerSteps.find((step) => step.id === stepId);

    if (offerStep) {
      offerStep.converting = true;
    }

    const funnelId = isReactivateStep ? this.reactivatePath : this.offerId;

    this.funnelStepService.convertToTemplate(stepId, is_global, funnelId).subscribe(
      (_) => {
        this.alertService.success(
          'Step converted to template successfully',
          false,
          `Your step template has been added to ${is_global ? 'Global Templates' : 'My Templates'}`
        );
        offerStep.converting = false;
      },
      (error) => {
        offerStep.converting = false;
        this.handleError(error);
      }
    );
  }

  refreshFilteredSteps(): void {
    if (this.offer && this.offer.offer_steps) {
      this.downsellOfferSteps = [...this.offer.offer_steps];
    } else {
      this.downsellOfferSteps = [];
    }
  }

  dropDownsell(event: CdkDragDrop<any[]>): void {
    if (!this.stepsReordering) {
      this.dropOfferSteps(
        event,
        this.downsellOfferSteps,
        this.offer.offer_steps,
        this.offerId,
        (response: Funnel) => {
          this.offer.is_modified = response.is_modified;
          this.isPublishable = this.offer.is_modified;
          this.originalOfferSteps = [...this.offer.offer_steps];
        }
      );
    }
  }

  dropReactivate(event: CdkDragDrop<any[]>): void {
    if (!this.stepsReordering && this.reactivateOffer) {
      const reactivateOfferSteps = this.reactivateOffer.offer_steps || [];
      this.dropOfferSteps(
        event,
        this.reactivateOfferSteps,
        reactivateOfferSteps,
        this.reactivatePath,
        (response: Funnel) => {
          this.reactivateOffer.is_modified = response.is_modified;
          this.isPublishable = true;
          this.originalReactivateOfferSteps = [...this.reactivateOfferSteps];
        }
      );
    }
  }

  private dropOfferSteps(
    event: CdkDragDrop<any[]>,
    filteredSteps: FunnelStep[],
    allOfferSteps: FunnelStep[],
    funnelId: number,
    onSuccess: (response: Funnel) => void
  ): void {
    const previousIndex = allOfferSteps.findIndex(
      (step) => step.id === filteredSteps[event.previousIndex].id
    );
    const currentIndex = allOfferSteps.findIndex(
      (step) => step.id === filteredSteps[event.currentIndex].id
    );

    moveItemInArray(filteredSteps, event.previousIndex, event.currentIndex);
    moveItemInArray(allOfferSteps, previousIndex, currentIndex);

    allOfferSteps.forEach((step, index) => {
      step.is_first_step = index === 0;
      const nextStepId = index < allOfferSteps.length - 1 ? allOfferSteps[index + 1].id : null;
      step.inputs.forEach((input: any) => {
        if (!input.has_response_step) {
          input.next_step = nextStepId;
        }
      });
    });

    const data = {
      id: funnelId,
      resourcetype: FunnelType.Product,
      steps: allOfferSteps.map((step) => ({
        id: step.id,
        is_first_step: step.is_first_step,
        inputs: step.inputs.map((input: any) => ({
          id: input.id,
          next_step: input.next_step,
        })),
      })),
    };

    this.stepsReordering = true;
    this.funnelService.drop(funnelId, data).subscribe(
      (response: Funnel) => {
        onSuccess(response);
        this.stepsReordering = false;
        this.alertService.success('Steps reordered successfully');
      },
      (error) => {
        this.stepsReordering = false;
        this.handleError(error);
      }
    );
  }

  isStepLoading(stepId: number): boolean {
    const allSteps = [...(this.offerSteps || []), ...(this.reactivateOfferSteps || [])];
    const step = allSteps.find((s) => s.id === stepId);
    return step ? step.loading : false;
  }

  isStepConverting(stepId: number): boolean {
    const allSteps = [...(this.offerSteps || []), ...(this.reactivateOfferSteps || [])];
    const step = allSteps.find((s) => s.id === stepId);
    return step ? step.converting : false;
  }

  isStepTogglingStatus(stepId: number): boolean {
    return this.stepsTogglingStatus.has(stepId);
  }

  getDiscountSettingFromStep(step: FunnelStep) {
    let discountSetting = null;

    if (step) {
      if (step.id && step.id in this.stepDiscounts) {
        discountSetting = this.stepDiscounts[step.id];
      } else {
        discountSetting = getDiscountSettingFromStep(step);

        if (step.id) {
          this.stepDiscounts[step.id] = discountSetting; // cache the discount setting
        }
      }
    }

    return discountSetting;
  }

  saveOffer(): void {
    this.navigate(this.isAdmin ? ['steps', 'admin', 'retention'] : ['steps', getOfferBuilderRoot(this.currentSection)]);
  }

  openPreviewPopup(): void {
    this.ngxSmartModalService.getModal('offerPreviewPopup').open();
  }

  get offerName(): string {
    return this.offer ? OfferStages[this.offer.offer_intent] : '--';
  }

  get isActiveSubscription(): boolean {
    return this.offer && this.offer.offer_intent === OfferIntents.CancelSubscription;
  }

  get bannerTitle(): string {
    let title: string;

    if (this.segmentId) {
      title = `Segment: ${this.segment ? this.segment.name : '--'}`;
    } else {
      title = `Offer Group - Customer Stage: ${this.offer ? OfferStages[this.offer.offer_intent] : '--'}`;
    }

    return title;
  }

  get bannerSubtitle(): string {
    if (this.segmentId) {
      return 'This group contains the retention offers for this segment within the selected customer stage. You can reorder, enable or disable, edit, or add new offers as needed.';
    }
    return this.stepHeaderDetails.retention.stageDescription;
  }

  getFormattedDate(date: string) {
    const lastModifiedMoment = moment(date).tz('EST');

    const lastModified = {
      time: lastModifiedMoment.format('HH:mm:ss z'), // "16:18:10 EST"
      date: lastModifiedMoment.format('DD MMM, YYYY'), // "20 Jan, 2025"
    };
    return `${lastModified.date} - ${lastModified.time}`;
  }

  get isAdmin(): boolean {
    return this.isAdminView && this.user && this.user.is_staff;
  }

  get shouldShowControls(): boolean {
    return this.offer && this.originalOfferSteps && this.originalOfferSteps.length > 0;
  }

  get isStageEmpty(): boolean {
    return !this.offer || (this.offer && this.offer.offer_steps.length === 0);
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.complete();
    this.sideNav.setSideNavExpanded(true);
  }
}
